import React from 'react';
import Nav from '../components/fay/layout/nav';
import Search from '../components/lamar/common/search';
import './prop.css'
import Navbtn from '../components/fay/common/navbtn';
import boldhome from '../assets/boldhome.png'
import about from '../assets/about.png'
import prop from '../assets/prop.png'
import contact from '../assets/contact.png'

const Properties = () => {
  return (
    <>
      <Nav>
        <Navbtn 
        link="/"
        navicon={boldhome}
        page="Home"
        selected="selected"
        />
        <Navbtn 
        link="aboutus"
        navicon={about}
        page="About us"
        />
        <Navbtn 
        link="properties"
        navicon={prop}
        page="Properties"
        />
        <Navbtn 
        link="contactus"
        navicon={contact}
        page="Contact"
        />
        </Nav>

      <section className='header'>
        <div className="hero-content">
          <h1>Find Your Dream Property</h1>
          <p>
            Browse through our curated selection of premium <br />
            properties across the country
          </p> 
            <Search />
        </div>
    
      </section>

      <section className='avalibleprops'>
        <div className='yellowdiv'> 
            <div className='yellowdiv1'> 
                <div className='ydiv1'>
                    <div className='ychild1'>
                        <h2 className='avaptext'> Available Properties</h2> 
                        <h2 className='nine'>9 properties found</h2>
                    </div>
                    <div className='ydiv2'>
                        <div className='ydesdiv'>
                            <div className='browndiv'>
                               <h2 className='alll'>All</h2>
                            </div>
                            <div className='whitediv'>
                                 <h2 className='alll b'>For sale</h2>
                            </div>
                             <div className='whitediv'>
                                 <h2 className='alll b'>Rent</h2>
                            </div>
                        </div>
                        <div className='morefilters'>
                            <div className='micon'></div>
                            <h2 className='moretext'>More filters </h2> </div>  
                    </div>
                </div>
            </div>
        </div>
      </section>
    </>
  );
};

export default Properties;